import { capitalizeFirstLetter } from '../../../utils/formattingUtil';

export const handleRenderCountriesList = (selectedCountries: string[]) => {
    const updatedCountryNames = selectedCountries.map(country => capitalizeFirstLetter(country.toLowerCase()));
    if (updatedCountryNames.length > 2) {
        return `${updatedCountryNames.slice(0, 2).join(', ')} and ${updatedCountryNames.length - 2} more`
    }
    return updatedCountryNames.join(', ')
}
